let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bfWCF")).then(() => parcelRequire('ktpa5'));